/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const VLINDER_LOGO = require("./res/images/vLogo.png");
export const LOCATION_NOT_FOUND = require("./res/images/locationNotFound.png");
export const TEXTBOX = require("./res/images/textBox.png");
export const THUMB_NAIL = require("./res/images/default-video.png");
export const NO_IMAGE = require("./res/images/no_image.jpg");
export const PROV_CARD_BG_WALLPAPER = require("./res/images/cert.png");
export const BARCODE_LOGO = require('./res/images/barcode.png');
export const LEAF_LOGO = require('./res/images/leaf.png');
export const BATCH_LOGO = require('./res/images/paper.png');
export const DATE_LOGO = require('./res/images/calendar-2.png');
export const CHOOSE_GIF_URI = require('./res/gif/choose.gif');

export const IMAGES = [
  VLINDER_LOGO,
  LOCATION_NOT_FOUND,
  TEXTBOX,
  THUMB_NAIL,
  NO_IMAGE,
  PROV_CARD_BG_WALLPAPER,
  BARCODE_LOGO,
  BATCH_LOGO,
  LEAF_LOGO,
  DATE_LOGO,
  CHOOSE_GIF_URI
];
